<template>
  <div class="kr-option pointer overflow-hidden py-1">
    <div class="d-flex align-items-center goal-row mb-1">
      <span class="icon-wrapper flex-center"><i class="goal-icon-greyed flex-shrink-0"></i></span>
      <span class="text-secondary goal-title text-truncate ml-2" :title="goalTitle" v-no-capture>{{
        goalTitle
      }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="icon-wrapper flex-center"><i class="kr-icon"></i></span>
      <span class="ml-2 text-truncate" :title="option.label" v-no-capture>{{ option.label }}</span>
    </div>
  </div>
</template>

<script>
/**
 * This provides the template for the individual items in KR filter dropdown
 */
export default {
  name: 'KrListItemTemplate',
  props: ['option'],
  computed: {
    goalTitle() {
      const goalId = this.option.goalId
      const goal = this.$store.getters.goalById(goalId)
      return goal.title
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(15px, 15px);
}
</style>
